import { NSTable } from 'bricks';
import { useProFormaSocketContext } from '../../socketContext/ProFormaSocketProvider';
import PricingRow from './PricingRow';
import './ProFormaPricingPerLotSize.scss';

const TH_CLASS = 'NSTable__thead__tr__th align-middle py-2 px-3';

const ProFormaPricingPerLotSize = () => {
    const { residentialLotMixes, handleUpdateResidentialLotMix } = useProFormaSocketContext();
    const rows = residentialLotMixes?.residentialLotMixes ?? [];

    const updatePricing = (lotMixId: number, dataKey: 'costPerFrontFoot' | 'pricePerLot', value: number | null) => {
        if (handleUpdateResidentialLotMix) handleUpdateResidentialLotMix(lotMixId, dataKey, value);
    };

    if (rows.length === 0) {
        return (
            <div className="ProFormaPricingPerLotSize m-3 text-muted">
                Add lot sizes on the General Information tab to set pricing.
            </div>
        );
    }

    return (
        <div className="ProFormaPricingPerLotSize m-3">
            <NSTable className="NSTable ProFormaPricingPerLotSize__table mb-0">
                <thead className="NSTable__thead">
                    <tr className="NSTable__thead__tr">
                        <th className={TH_CLASS}>Lot name</th>
                        <th className={`${TH_CLASS} text-right`}>Lot size (ft)</th>
                        <th className={`${TH_CLASS} text-right`}>$ / Front foot</th>
                        <th className={`${TH_CLASS} text-right`}>Price per lot</th>
                    </tr>
                </thead>
                <tbody className="NSTable__tbody">
                    {rows.map(row => (
                        <PricingRow key={row.id} row={row} onUpdate={updatePricing} />
                    ))}
                </tbody>
            </NSTable>
        </div>
    );
};

export default ProFormaPricingPerLotSize;
